// Whether an order can be edited, mirroring the back's guards (see the back's
// docs/order-edit.md): a modifiable status, an edit candidate (the SGA has
// registered it and it keeps the lines the customer asked for) and no edit
// still waiting for the SGA.
export const EDITABLE_ORDER_STATUSES = [
  'REGISTRADO', 'NO_REGISTRADO', 'REGISTRADO_OL', 'LIBERADO', 'RETENIDO',
  'RECUPERADO', 'ACTUALIZACION_RESER', 'OUT_OF_STOCK', 'EN_ESPERA', 'CANCELADO'
];

export function canEditOrder(order) {
  if (!order) return false;
  return EDITABLE_ORDER_STATUSES.includes(order.status)
    && order.is_edit_candidate === true
    && order.edit_in_progress !== true;
}
